import { Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { ButtonComponent } from '@shared/components/ui/button/button.component';
import { DialogService } from '@shared/services/dialog.service';

import { LocationCoordinates } from './location-picker.component';
import {
  LocationPickerDialogComponent,
  LocationPickerDialogData,
} from './location-picker-dialog.component';

@Component({
  selector: 'app-location-picker-trigger',
  imports: [ButtonComponent],
  template: `
    <app-button
      size="sm"
      variant="outline"
      startIcon="map"
      [disabled]="readOnly && !hasValidCoordinates"
      (btnClick)="openMap()"
    >
      {{ readOnly ? 'Ver en el mapa' : 'Seleccionar en el mapa' }}
    </app-button>
  `,
})
export class LocationPickerTriggerComponent {
  @Input() latitud: string | number | null | undefined;
  @Input() longitud: string | number | null | undefined;
  @Input() readOnly = false;

  @Output() coordinatesChange = new EventEmitter<LocationCoordinates>();

  private readonly dialogService = inject(DialogService);

  get hasValidCoordinates(): boolean {
    return this.isValidCoordinate(this.latitud, -90, 90)
      && this.isValidCoordinate(this.longitud, -180, 180);
  }

  openMap(): void {
    const data: LocationPickerDialogData = {
      latitud: this.latitud,
      longitud: this.longitud,
      readOnly: this.readOnly,
    };

    this.dialogService
      .openForm(LocationPickerDialogComponent, {
        size: 'xl',
        data,
        config: { maxHeight: '90vh' },
      })
      .afterClosed()
      .subscribe((coordinates) => {
        if (coordinates && !this.readOnly) {
          this.coordinatesChange.emit(coordinates);
        }
      });
  }

  private isValidCoordinate(
    value: string | number | null | undefined,
    min: number,
    max: number,
  ): boolean {
    if (value === null || value === undefined || value === '') {
      return false;
    }

    const coordinate = Number(value);
    return Number.isFinite(coordinate) && coordinate >= min && coordinate <= max;
  }
}
